import React from 'react'
import Loading from '../components/elements/loading'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

const LoadingContainer = () => {
    const loading = useSelector(state => state.AppReducer.loading)
    const { t } = useTranslation()
    return <Loading loading={loading} message={t('message.waiting')} />
}

export default LoadingContainer
